import type { HTMLAttributes } from 'react';
import { tlwTwMerge } from '@trg/utils';
import { Breadcrumb, type BreadcrumbProps } from '../breadcrumb';

export type HeadlineProps = HTMLAttributes<HTMLElement> & {
  mainTitle?: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbProps['navList'];
  hasWrapClass?: boolean;
};

export function Headline({
  mainTitle,
  subtitle,
  breadcrumbs,
  hasWrapClass = true,
  className,
  children,
  ...props
}: HeadlineProps) {
  return (
    <header
      className={tlwTwMerge(
        'tlw-flex tlw-justify-between tlw-items-center',
        hasWrapClass && 'tlw-container-box tlw-pt-5 tlw-pb-3 lg:tlw-pt-3',
        className
      )}
      {...props}
    >
      <div className="tlw-flex tlw-flex-col tlw-gap-1 lg:tlw-flex-row lg:tlw-items-center">
        {Boolean(breadcrumbs?.length) && <Breadcrumb navList={breadcrumbs} />}

        {subtitle && (
          <p className="tlw-txt-zh-head-8 tlw-text-txt-700 tlw-py-1 tlw-pr-2">
            {subtitle}
          </p>
        )}

        {mainTitle && (
          <h1 className="tlw-txt-zh-head-2 tlw-text-txt-800">{mainTitle}</h1>
        )}
      </div>

      {children && <div>{children}</div>}
    </header>
  );
}
